/**
 * @deprecated use assumeExhaustion from shared/lib/typeHelpers.no-deps.ts
 */
export const never = (x: never) => x
